import React, { useRef, useState } from 'react';
import { useRequest } from 'ahooks';
import { Layout, Justify, Segment, SelectOptionWithGroup } from 'tea-component';
import Schedule from './components/Schedule';
import KeyMetricsCard from './components/KeyMetricsCard';
import usePageLog from '@gp/hooks/usePageLog';
import useKeyMetricsList from './hooks/useKeyMetricsList';
import { getUpdateTime } from '@gp/services/global';
import { getNewKeyMetrics } from '@gp/services/overview';
import SearchCommon from '@gp/components/SearchCommon';
// import Filter from '@gp/components/Filter';
import type { KeyMetricsCardListItemType } from './types';
import './index.scss';
import '@gp/assets/css/pages/pipelineOverview.scss';
import { fetchProjects } from '@gp/services/projectDetail';
import {
  formatSearchProjectsResults,
  toProjectDetails,
} from '@gp/utils/project';
// import {
//   formatDateForFilter,
//   getCalendarDataFetchParams,
//   updateIcons,
//   getSegmentOptions,
//   getDefaultDates,
//   getMilestoneOptions,
//   getMilestoneOptionsForms,
// } from './components/Schedule/utils';
const { Content } = Layout;

const getMaxNum = (list?: KeyMetricsCardListItemType[]): number => {
  if (!Array.isArray(list) || !list.length) return Number.NaN;
  return Math.max(...list.map((item) => item?.num));
};

const Overview = () => {
  const contextDom = useRef(null);
  const scrollBody = useRef(null);
  const [searchList, setSearchList] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const headerTitle = 'Overview';
  const currentPage = 'overview';
  const searchPlaceholder = 'Search project name to go to Project Detail tab';
  const hasSearchBtn = false;
  // // 日历、月历
  // const [activeTab, setActiveTab] = useState<ScheduleTabTypes>(initialTab as any);
  // // Official Gate Reviews、All Milestones、Launch Schedule
  // const [activeSegment, setActiveSegment] = useState<ScheduleSegmentTypes>(initialSegment as any);

  const { data: updateTime } = useRequest(getUpdateTime);

  const { loading: keyMetricsLoading, data: keyMetricsData } = useRequest(
    getNewKeyMetrics,
    {
      defaultParams: [],
    },
  );

  const cardList: KeyMetricsCardListItemType[] = useKeyMetricsList({
    loading: keyMetricsLoading,
    data: keyMetricsData as any,
  });

  const max = getMaxNum(cardList);

  // 页面级打点上报日志信息
  usePageLog({
    pageId: 'PIPELINE_DASHBOARD',
  });

  const handleGoToProjectDetails = (payload: any, isJump = true) => {
    const { project_id: id, name } = payload || {};
    return toProjectDetails({ id, name }, null, isJump);
  };

  return (
    <Content
      className="dbg-page dbg-pipline-dashboard dbg-page-scroll-body"
      ref={scrollBody}
    >
      <Content.Header title={headerTitle} className="dbg-header">
        {!!updateTime?.trim() && (
          <div className="header-des">Updated on {updateTime}</div>
        )}
      </Content.Header>

      <Content.Body full ref={contextDom} className="">
        <Justify
          className="dbg-pipeline-justify-container"
          left={
            <h3 className="dbg-pipeline-justify-container-title">
              Key Metrics
            </h3>
          }
          right={
            <div className="dbg-pipeline-justify-container-right">
              <SearchCommon
                placeholder={searchPlaceholder}
                currentPage={currentPage}
                hasSearchBtn={hasSearchBtn}
                getSearchList={fetchProjects}
                formatSearchResults={formatSearchProjectsResults}
                onRightBtnClick={handleGoToProjectDetails}
                searchList={searchList}
                setSearchList={setSearchList}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
              />
            </div>
          }
        />

        <div className="dbg-pipeline-card">
          {cardList?.map((item, index) => (
            <KeyMetricsCard
              key={index}
              loading={keyMetricsLoading}
              data={item}
              max={max}
            />
          ))}
        </div>

        <Schedule
          scrollBody={scrollBody}
          headerTitle={headerTitle}
          headerOther={!!updateTime?.trim() ? `Updated on ${updateTime}` : ''}
          currentPage={currentPage}
          hasSearchBtn={hasSearchBtn}
          searchPlaceholder={searchPlaceholder}
          formatSearchResults={formatSearchProjectsResults}
          getSearchList={fetchProjects}
          searchList={searchList}
          setSearchList={setSearchList}
          searchVal={searchVal}
          setSearchVal={setSearchVal}
        />
      </Content.Body>
    </Content>
  );
};

export default Overview;
